import {
  GET_PARAMETROS_LOCAIS_INIT,
  GET_PARAMETROS_LOCAIS_SUCCESS,
  UPDATE_PARAMETROS_LOCAIS_INIT,
  UPDATE_PARAMETROS_LOCAIS_SUCCESS,
  PARAMETROS_LOCAIS_ERROR_MSG,
  CLEAR_PARAMETROS_LOCAIS
} from '../actionTypes';

const INIT_STATE = {
  loading: false,
  isUpdated: false,
  isError: false,
  isReceived: false,
  parametrosLocais: null,
  msg: ''
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_PARAMETROS_LOCAIS_INIT:
      return { ...state, loading: true, isUpdated: false, isReceived: false };
    case GET_PARAMETROS_LOCAIS_SUCCESS: {
      const { parametrosLocais } = action.payload;
      return {
        ...state,
        parametrosLocais,
        loading: false,
        isError: false,
        isReceived: true
      };
    }
    case UPDATE_PARAMETROS_LOCAIS_INIT:
      return {
        ...state,
        loading: true,
        isUpdated: false,
        isReceived: false
      };
    case UPDATE_PARAMETROS_LOCAIS_SUCCESS: {
      const { msg } = action.payload;
      return {
        ...state,
        loading: false,
        msg,
        isUpdated: true,
        isError: false,
        isReceived: false
      };
    }
    case PARAMETROS_LOCAIS_ERROR_MSG: {
      const { msg } = action.payload;
      return { ...state, loading: false, isError: true, isReceived: false, msg };
    }
    case CLEAR_PARAMETROS_LOCAIS: {
      return {
        ...state,
        isUpdated: false,
        isError: false,
        loading: false,
        isReceived: false,
        msg: ''
      };
    }
    default:
      return { ...state };
  }
};
